'use strict';

import Autocomplete from "../Shared/Autocomplete/Autocomplete";
import { searchCatTagAutocompleteFieldElements } from "./elements/searchCatTagAutocompleteFieldElements";
import { xhrTagAndCategorySearchSuggestions } from "./xhr/xhrSearchCatTagAutocomplete";

export default class SearchCatTagAutocompleteField extends Autocomplete
{
    constructor() {
        super(
            searchCatTagAutocompleteFieldElements(),
            xhrTagAndCategorySearchSuggestions,
            value => {
                this.useSelectedValue(value);
            },
            null,
            0,
            false
        );
    }

    useSelectedValue(value) {
        this.elements.input.value = value.title;
    }
}
